import React, { useState ,useRef,useEffect} from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import SaveButtonWithModal from '../../components/SaveButtonWithModel';
import { useNavigate } from 'react-router-dom';

const Dropdown1 = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState({});
  
  // Scroll related states
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);

  const toggleCircle = (item) => {
      setSelectedCircles((prev) => ({
          ...prev,
          [item]: !prev[item],
      }));
  };

  const handleSelect = (item) => {
      setSelectedItems(prev => {
          if (prev.includes(item)) {
              return prev.filter(i => i !== item);
          } else {
              return [...prev, item];
          }
      });
      
      if (typeof onChange === "function") {
          onChange(type, item);
      }
  };

  // Calculate thumb height based on content height
  useEffect(() => {
      const content = contentRef.current;
      if (!content) return;

      const updateThumbHeight = () => {
          const { scrollHeight, clientHeight } = content;
          const visibleRatio = clientHeight / scrollHeight;
          setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
      };

      updateThumbHeight();
      window.addEventListener("resize", updateThumbHeight);
      return () => window.removeEventListener("resize", updateThumbHeight);
  }, [isOpen, items]);

  // Handle scroll events
  const handleScroll = () => {
      const content = contentRef.current;
      if (!content) return;

      const { scrollTop, scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const scrollRatio = scrollTop / maxScrollTop;
      const trackHeight = content.clientHeight - thumbHeight;
      setScrollTop(scrollRatio * trackHeight);
  };

  // Mouse down on thumb
  const handleThumbMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();

      setIsDragging(true);
      setStartY(e.clientY);
      setStartScrollTop(contentRef.current.scrollTop);

      document.addEventListener("mousemove", handleThumbMouseMove);
      document.addEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "grabbing";
  };

  // Mouse move when dragging thumb
  const handleThumbMouseMove = (e) => {
      if (!isDragging) return;

      const deltaY = e.clientY - startY;
      const content = contentRef.current;
      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const trackHeight = clientHeight - thumbHeight;

      const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
      const newScrollTop = Math.min(
          Math.max(0, startScrollTop + scrollDelta),
          maxScrollTop
      );

      content.scrollTop = newScrollTop;
  };

  // Mouse up when dragging thumb
  const handleThumbMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleThumbMouseMove);
      document.removeEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "";
  };

  // Click on track to jump to position
  const handleTrackClick = (e) => {
      const content = contentRef.current;
      if (!content || e.target === thumbRef.current) return;

      const track = e.currentTarget;
      const trackRect = track.getBoundingClientRect();
      const clickPosition = e.clientY - trackRect.top;
      const thumbCenter = thumbHeight / 2;
      const scrollRatio =
          (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      content.scrollTop = scrollRatio * maxScrollTop;
  };

  // Button scroll handlers
  const handleButtonScroll = (direction) => {
      if (contentRef.current) {
          contentRef.current.scrollBy({
              top: direction === 'up' ? -50 : 50,
              behavior: 'smooth'
          });
      }
  };

  return (
      <div className="flex flex-col w-full relative">
          {/* Button showing selected items */}
          <span className="text-[6px] md:text-[20px] md:pl-2 md:mb-3 font-extrabold">
      {isProjectDropdown ? "" : "CONTRACT"}
  </span>
          <div className="flex relative z-50 w-fit">
              <button
                  onClick={() => {
                      if (isProjectDropdown && selectedItems.includes("Funding")) {
                          window.location.href = "/funding";
                      } else {
                          setIsOpen(prev => !prev);
                      }
                  }}
                  className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
              >
               <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
  {selectedItems.length > 0 ? selectedItems[0] : "-"}
</span>
              </button>

              <div
                  className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                  onClick={() => setIsOpen(prev => !prev)}
              >
                  <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                      alt="expand"
                      className="w-2 h-[10px] md:w-6 md:h-[24px]"
                  />
              </div>
          </div>

          <AnimatePresence>
              {isOpen && (
                  <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                  >
                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('up');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                  alt="Scroll up" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>

                      <div className="custom-scroll-area">
                          <ul
                              className="custom-scroll-content"
                              ref={contentRef}
                              onScroll={handleScroll}
                          >
                          <li className="flex items-center justify-between px-2 py-1 mb-2">
  <span className="text-[6px] md:text-[20px] font-semibold">
      {isProjectDropdown ? "Purpose" : "Contract"}
  </span>
  <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
      alt="icon"
      className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
      onClick={(e) => {
          e.stopPropagation(); // Prevent the li onClick from firing
          setIsOpen(false); // Close the dropdown
      }}
  />
</li>
                              
                              {items.map((item, index) => (
                                  <li
                                      key={index}
                                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                          selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                      }`}
                                      onClick={() => handleSelect(item)}
                                  >
                                      <span className="text-black text-[4px] md:text-[18px]">
                                          {item}
                                      </span>
                                      <div
                                          className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                              selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                          }`}
                                      ></div>
                                  </li>
                              ))}
                          </ul>
                          <div className="custom-scroll-track" onClick={handleTrackClick}>
                              <div
                                  ref={thumbRef}
                                  className="custom-scroll-thumb"
                                  style={{
                                      height: `${thumbHeight}px`,
                                      top: `${scrollTop}px`,
                                      cursor: isDragging ? "grabbing" : "grab",
                                  }}
                                  onMouseDown={handleThumbMouseDown}
                              ></div>
                          </div>
                      </div>

                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('down');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                  alt="Scroll down" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>
                  </motion.div>
              )}
          </AnimatePresence>
          <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
              {isProjectDropdown
                  ? "Select type of Produce"
                  : `Select type of ${type === "FACILITATOR" ? "Contract" : label}`}
          </p>

          <style jsx>{`
              .custom-scroll-area {
                  position: relative;
                  max-height: 200px;
                  display: flex;
                  overflow: hidden;
              }

              .custom-scroll-content {
                  flex: 1;
                  overflow-y: scroll;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                  padding-right: 4px;
              }

              .custom-scroll-content::-webkit-scrollbar {
                  display: none;
              }

              .custom-scroll-track {
                  width: 14px;
                  background: #e7ebeb;
                  border-radius: 3px;
                  position: relative;
                  margin-left: 4px;
                  cursor: pointer;
              }

              .custom-scroll-thumb {
                  width: 100%;
                  background: #979797;
                  border-radius: 3px;
                  position: absolute;
                  right: 0;
                  transition: background 0.2s;
              }

              .custom-scroll-thumb:hover {
                  background: #444;
              }

              @media (max-width: 768px) {
                  .custom-scroll-track {
                      width: 4px;
                      margin-left: 2px;
                  }
                  .custom-scroll-area {
                      position: relative;
                      max-height: 150px;
                      display: flex;
                      overflow: hidden;
                      width: 100%;
                  }
              }
          `}</style>
      </div>
  );
};
const Dropdown = ({ label, items, type, isProjectDropdown, onChange,activeTab }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedCircles, setSelectedCircles] = useState({});
    
    // Scroll related states
    const contentRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [thumbHeight, setThumbHeight] = useState(40);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [startScrollTop, setStartScrollTop] = useState(0);
    const thumbRef = useRef(null);

    const toggleCircle = (item) => {
        setSelectedCircles((prev) => ({
            ...prev,
            [item]: !prev[item],
        }));
    };

    const handleSelect = (item) => {
        setSelectedItems(prev => {
            if (prev.includes(item)) {
                return prev.filter(i => i !== item);
            } else {
                return [...prev, item];
            }
        });
        
        if (typeof onChange === "function") {
            onChange(type, item);
        }
    };

    // Calculate thumb height based on content height
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        const updateThumbHeight = () => {
            const { scrollHeight, clientHeight } = content;
            const visibleRatio = clientHeight / scrollHeight;
            setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
        };

        updateThumbHeight();
        window.addEventListener("resize", updateThumbHeight);
        return () => window.removeEventListener("resize", updateThumbHeight);
    }, [isOpen, items]);

    // Handle scroll events
    const handleScroll = () => {
        const content = contentRef.current;
        if (!content) return;

        const { scrollTop, scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const scrollRatio = scrollTop / maxScrollTop;
        const trackHeight = content.clientHeight - thumbHeight;
        setScrollTop(scrollRatio * trackHeight);
    };
    const [setActiveTab] = useState("individual");

    // Mouse down on thumb
    const handleThumbMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsDragging(true);
        setStartY(e.clientY);
        setStartScrollTop(contentRef.current.scrollTop);

        document.addEventListener("mousemove", handleThumbMouseMove);
        document.addEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "grabbing";
    };

    // Mouse move when dragging thumb
    const handleThumbMouseMove = (e) => {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const content = contentRef.current;
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const trackHeight = clientHeight - thumbHeight;

        const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
        const newScrollTop = Math.min(
            Math.max(0, startScrollTop + scrollDelta),
            maxScrollTop
        );

        content.scrollTop = newScrollTop;
    };

    // Mouse up when dragging thumb
    const handleThumbMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleThumbMouseMove);
        document.removeEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "";
    };

    // Click on track to jump to position
    const handleTrackClick = (e) => {
        const content = contentRef.current;
        if (!content || e.target === thumbRef.current) return;

        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickPosition = e.clientY - trackRect.top;
        const thumbCenter = thumbHeight / 2;
        const scrollRatio =
            (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        content.scrollTop = scrollRatio * maxScrollTop;
    };

    // Button scroll handlers
    const handleButtonScroll = (direction) => {
        if (contentRef.current) {
            contentRef.current.scrollBy({
                top: direction === 'up' ? -50 : 50,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="flex flex-col w-full relative">
            {/* Button showing selected items */}
            <h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2">
        {activeTab === "individual" ? "ASSOCIATION (ASS)" : "CONTRACT"}
      </h1>


            <div className="flex relative z-50 w-fit">
                <button
                    onClick={() => {
                        if (isProjectDropdown && selectedItems.includes("Funding")) {
                            window.location.href = "/funding";
                        } else {
                            setIsOpen(prev => !prev);
                        }
                    }}
                    className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
                >
                 <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
    {selectedItems.length > 0 ? selectedItems[0] : "-"}
</span>
                </button>

                <div
                    className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>

            <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
          >
            <div className="w-full flex justify-end py-1">
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleButtonScroll('up');
                }}
                className="p-1"
              >
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                  alt="Scroll up" 
                  className="w-3 h-3"
                />
              </button>
            </div>

            <div className="custom-scroll-area">
              <ul
                className="custom-scroll-content"
                ref={contentRef}
                onScroll={handleScroll}
              >
                <li className="flex items-center justify-between px-2 py-1 mb-2">
                  <span className="text-[6px] md:text-[20px] font-semibold">
                    {activeTab === "individual" ? "Association" : "Contract"}
                  </span>
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
                    alt="icon"
                    className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsOpen(false);
                    }}
                  />
                </li>
                
                {activeTab === "individual" ? (
                  items.map((item, index) => (
                    <li
                      key={index}
                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                        selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                      }`}
                      onClick={() => handleSelect(item)}
                    >
                      <span className="text-black text-[4px] md:text-[18px]">
                        {item}
                      </span>
                      <div
                        className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                          selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                        }`}
                      ></div>
                    </li>
                  ))
                ) : (
                  [
                    "Association (ASS)",
                    "Alliance (ALL)",
                    "Community (COM)",
                    "Cooperative (COP)",
                    "Chama (CHA)",
                    "Groups (GRO)",
                    "Membership (MEM)",
                    "Savings & Credit (SAC)",
                    "Stokvel (STO)",
                    "Union (UNO)"
                  ].map((item, index) => (
                    <li
                      key={index}
                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                        selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                      }`}
                      onClick={() => handleSelect(item)}
                    >
                      <span className="text-black text-[4px] md:text-[18px]">
                        {item}
                      </span>
                      <div
                        className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                          selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                        }`}
                      ></div>
                    </li>
                  ))
                )}
              </ul>
              <div className="custom-scroll-track" onClick={handleTrackClick}>
                <div
                  ref={thumbRef}
                  className="custom-scroll-thumb"
                  style={{
                    height: `${thumbHeight}px`,
                    top: `${scrollTop}px`,
                    cursor: isDragging ? "grabbing" : "grab",
                  }}
                  onMouseDown={handleThumbMouseDown}
                ></div>
              </div>
            </div>

            <div className="w-full flex justify-end py-1">
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleButtonScroll('down');
                }}
                className="p-1"
              >
                <img 
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                  alt="Scroll down" 
                  className="w-3 h-3"
                />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
            {activeTab === "individual" ? "Submit contract" : "Submit contract"}
      </p>

            <style jsx>{`
                .custom-scroll-area {
                    position: relative;
                    max-height: 200px;
                    display: flex;
                    overflow: hidden;
                }

                .custom-scroll-content {
                    flex: 1;
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    padding-right: 4px;
                }

                .custom-scroll-content::-webkit-scrollbar {
                    display: none;
                }

                .custom-scroll-track {
                    width: 14px;
                    background: #e7ebeb;
                    border-radius: 3px;
                    position: relative;
                    margin-left: 4px;
                    cursor: pointer;
                }

                .custom-scroll-thumb {
                    width: 100%;
                    background: #979797;
                    border-radius: 3px;
                    position: absolute;
                    right: 0;
                    transition: background 0.2s;
                }

                .custom-scroll-thumb:hover {
                    background: #444;
                }

                @media (max-width: 768px) {
                    .custom-scroll-track {
                        width: 4px;
                        margin-left: 2px;
                    }
                    .custom-scroll-area {
                        position: relative;
                        max-height: 150px;
                        display: flex;
                        overflow: hidden;
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};
const Dropdown2 = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCircles, setSelectedCircles] = useState({});
  
  // Scroll related states
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);

  const toggleCircle = (item) => {
      setSelectedCircles((prev) => ({
          ...prev,
          [item]: !prev[item],
      }));
  };

  const handleSelect = (item) => {
      setSelectedItems(prev => {
          if (prev.includes(item)) {
              return prev.filter(i => i !== item);
          } else {
              return [...prev, item];
          }
      });
      
      if (typeof onChange === "function") {
          onChange(type, item);
      }
  };

  // Calculate thumb height based on content height
  useEffect(() => {
      const content = contentRef.current;
      if (!content) return;

      const updateThumbHeight = () => {
          const { scrollHeight, clientHeight } = content;
          const visibleRatio = clientHeight / scrollHeight;
          setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
      };

      updateThumbHeight();
      window.addEventListener("resize", updateThumbHeight);
      return () => window.removeEventListener("resize", updateThumbHeight);
  }, [isOpen, items]);

  // Handle scroll events
  const handleScroll = () => {
      const content = contentRef.current;
      if (!content) return;

      const { scrollTop, scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const scrollRatio = scrollTop / maxScrollTop;
      const trackHeight = content.clientHeight - thumbHeight;
      setScrollTop(scrollRatio * trackHeight);
  };

  // Mouse down on thumb
  const handleThumbMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();

      setIsDragging(true);
      setStartY(e.clientY);
      setStartScrollTop(contentRef.current.scrollTop);

      document.addEventListener("mousemove", handleThumbMouseMove);
      document.addEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "grabbing";
  };

  // Mouse move when dragging thumb
  const handleThumbMouseMove = (e) => {
      if (!isDragging) return;

      const deltaY = e.clientY - startY;
      const content = contentRef.current;
      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      const trackHeight = clientHeight - thumbHeight;

      const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
      const newScrollTop = Math.min(
          Math.max(0, startScrollTop + scrollDelta),
          maxScrollTop
      );

      content.scrollTop = newScrollTop;
  };

  // Mouse up when dragging thumb
  const handleThumbMouseUp = () => {
      setIsDragging(false);
      document.removeEventListener("mousemove", handleThumbMouseMove);
      document.removeEventListener("mouseup", handleThumbMouseUp);
      document.body.style.cursor = "";
  };

  // Click on track to jump to position
  const handleTrackClick = (e) => {
      const content = contentRef.current;
      if (!content || e.target === thumbRef.current) return;

      const track = e.currentTarget;
      const trackRect = track.getBoundingClientRect();
      const clickPosition = e.clientY - trackRect.top;
      const thumbCenter = thumbHeight / 2;
      const scrollRatio =
          (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

      const { scrollHeight, clientHeight } = content;
      const maxScrollTop = scrollHeight - clientHeight;
      content.scrollTop = scrollRatio * maxScrollTop;
  };

  // Button scroll handlers
  const handleButtonScroll = (direction) => {
      if (contentRef.current) {
          contentRef.current.scrollBy({
              top: direction === 'up' ? -50 : 50,
              behavior: 'smooth'
          });
      }
  };

  return (
      <div className="flex flex-col w-full relative">
       
          <div className="flex relative z-50 w-fit">
              <button
                  onClick={() => {
                      if (isProjectDropdown && selectedItems.includes("Funding")) {
                          window.location.href = "/funding";
                      } else {
                          setIsOpen(prev => !prev);
                      }
                  }}
                  className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
              >
               <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
  {selectedItems.length > 0 ? selectedItems[0] : "-"}
</span>
              </button>

              <div
                  className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                  onClick={() => setIsOpen(prev => !prev)}
              >
                  <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                      alt="expand"
                      className="w-2 h-[10px] md:w-6 md:h-[24px]"
                  />
              </div>
          </div>

          <AnimatePresence>
              {isOpen && (
                  <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                  >
                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('up');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                  alt="Scroll up" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>

                      <div className="custom-scroll-area">
                          <ul
                              className="custom-scroll-content"
                              ref={contentRef}
                              onScroll={handleScroll}
                          >
                          <li className="flex items-center justify-between px-2 py-1 mb-2">
  <span className="text-[6px] md:text-[20px] font-semibold">
      {isProjectDropdown ? "Purpose" : "Association"}
  </span>
  <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750034880/Export_1_vurzim.png"
      alt="icon"
      className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
      onClick={(e) => {
          e.stopPropagation(); // Prevent the li onClick from firing
          setIsOpen(false); // Close the dropdown
      }}
  />
</li>
                              
                              {items.map((item, index) => (
                                  <li
                                      key={index}
                                      className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                          selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                      }`}
                                      onClick={() => handleSelect(item)}
                                  >
                                      <span className="text-black text-[4px] md:text-[18px]">
                                          {item}
                                      </span>
                                      <div
                                          className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                              selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                          }`}
                                      ></div>
                                  </li>
                              ))}
                          </ul>
                          <div className="custom-scroll-track" onClick={handleTrackClick}>
                              <div
                                  ref={thumbRef}
                                  className="custom-scroll-thumb"
                                  style={{
                                      height: `${thumbHeight}px`,
                                      top: `${scrollTop}px`,
                                      cursor: isDragging ? "grabbing" : "grab",
                                  }}
                                  onMouseDown={handleThumbMouseDown}
                              ></div>
                          </div>
                      </div>

                      <div className="w-full flex justify-end py-1">
                          <button 
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleButtonScroll('down');
                              }}
                              className="p-1"
                          >
                              <img 
                                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                  alt="Scroll down" 
                                  className="w-3 h-3"
                              />
                          </button>
                      </div>
                  </motion.div>
              )}
          </AnimatePresence>
      
          <style jsx>{`
              .custom-scroll-area {
                  position: relative;
                  max-height: 200px;
                  display: flex;
                  overflow: hidden;
              }

              .custom-scroll-content {
                  flex: 1;
                  overflow-y: scroll;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                  padding-right: 4px;
              }

              .custom-scroll-content::-webkit-scrollbar {
                  display: none;
              }

              .custom-scroll-track {
                  width: 14px;
                  background: #e7ebeb;
                  border-radius: 3px;
                  position: relative;
                  margin-left: 4px;
                  cursor: pointer;
              }

              .custom-scroll-thumb {
                  width: 100%;
                  background: #979797;
                  border-radius: 3px;
                  position: absolute;
                  right: 0;
                  transition: background 0.2s;
              }

              .custom-scroll-thumb:hover {
                  background: #444;
              }

              @media (max-width: 768px) {
                  .custom-scroll-track {
                      width: 4px;
                      margin-left: 2px;
                  }
                  .custom-scroll-area {
                      position: relative;
                      max-height: 150px;
                      display: flex;
                      overflow: hidden;
                      width: 100%;
                  }
              }
          `}</style>
      </div>
  );
};

const language = {

  FACILITATOR: [
 "Association (ASS)",  
"Alliance (ALL)",  
"Community (COM)",  
"Cooperative (COP)",  
"Chama (CHA)",  
"Groups (GRO)",  
"Membership (MEM)",  
"Savings & Credit (SAC)",  
"Stokvel (STO)",  
"Union (UNO)"


  ],


};
 
const language1 = {

    FACILITATOR: [
   "SHEDDULE A", "SHEDDULE A", "SHEDDULE C", "-"

    ],
  
  
  };
   
const language2 = {

    FACILITATOR: [
   // South Africa
  "Name of Association 1",  
"Name of Association 2",  
"Name of Association 3",  
"Name of Association 4",  
"Name of Association 5"

  
    ],
  
  
  }
const Market = (  onCertificatesUrlsChange) => {
  const [images, setImages] = useState(Array(2).fill(null));
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [showAgreementError, setShowAgreementError] = useState(false);
  const [activeTab, setActiveTab] = useState("individual");
  const navigate = useNavigate();
  // Add state for editable sections
  const [editableSections, setEditableSections] = useState({
    purpose: false,
    scope: false,
    purchase: false,
    obligationsFarmers: false,
    obligationsAggregator: false,
    forceMajeure: false,
    disputeResolution: false,
    governingLaw: false,
    miscellaneous: false,
    end: false

  });
  const EditButton = ({ section }) => (
    <div 
      className="flex items-center gap-1 cursor-pointer ml-2"
      onClick={() => setEditableSections(prev => ({
        ...prev,
        [section]: !prev[section]
      }))}
    >
      <span className="text-[8px] md:text-[12px]">Edit</span>
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750377052/Edit_fill_hbfrg4.png"
        alt="Edit"
        className="w-[10px] h-[10px] md:w-[38px] md:h-[38px]"
      />
    </div>
  );
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCircles, setSelectedCircles] = useState({});
  const [certFiles, setCertFiles] = useState(Array(4).fill(null));
  const [showModal, setShowModal] = useState(false);
  const [idFile, setIdFile] = useState(null);
  const [idImageUrl, setIdImageUrl] = useState(null);
  
  const handleDeleteImage = (index) => {
    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
    
    const newFiles = [...certFiles];
    newFiles[index] = null;
    setCertFiles(newFiles);
    
    // Update parent with filtered non-null images
    const filteredImages = newImages.filter(img => img !== null);
    if (onCertificatesUrlsChange) {
      onCertificatesUrlsChange(
        filteredImages.map(img => ({
          url: img.previewUrl,
          type: img.documentType,
          file: img.file
        }))
      );
    }
  };
 const [boxPlaceholders, setBoxPlaceholders] = useState([
    "Quality Standards",
    "Specifications",

  ]);
  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
  
    const imageData = {
      previewUrl: URL.createObjectURL(file),
      url: URL.createObjectURL(file), // Add url field
      file,
      name: file.name,
      type: file.type,
      size: file.size,
      documentType: boxPlaceholders[index],
      cloudinaryUrl: null // Initialize cloudinaryUrl
    };
  
    const newImages = [...images];
    newImages[index] = imageData;
    setImages(newImages);
  
    const newFiles = [...certFiles];
    newFiles[index] = file;
    setCertFiles(newFiles);
  
    if (onCertificatesUrlsChange) {
      onCertificatesUrlsChange(
        newImages.filter(img => img !== null).map(img => ({
          url: img.previewUrl,
          type: img.documentType,
          file: img.file
        }))
      );
    }
  };
  const [sectionContent, setSectionContent] = useState({
    purpose: "The purpose of this Agreement is to establish a framework for the Aggregator to purchase agricultural produce from the Farmers on a regular and consistent basis, thereby ensuring a stable market for the Farmers and continuous supply for the Aggregator.",
    scope: `2.1 The Farmers agree to supply, and the Aggregator agrees to purchase, the agreed quantity and quality of produce during the term of this Agreement.
    2.2 The produce to be supplied shall include, but is not limited to: [Insert List of Crops].
    2.3 The produce shall meet the quality and grading standards as specified in Schedule A (attached to this Agreement).`,
    purchase: `3.1 The Aggregator agrees to purchase a minimum quantity of [Insert Volume] per harvest season.
    3.2 Pricing shall be based on market rates as agreed upon and stated in Schedule B.
    3.3 Payments shall be made within [Insert Days] days of delivery, via [Insert Payment Method].
    3.4 Delivery schedule shall be as mutually agreed.`,
    obligationsFarmers: `- The Farmers shall produce in accordance with agreed specifications;
    - Adhere to sustainable farming practices;
    - Ensure timely delivery of produce to Aggregator representatives.`,
    obligationsAggregator: `- Provide technical guidance where applicable;
    - Offer fair compensation for produce;
    - Facilitate access to credit facilities or input materials where necessary;
    - Honor all payment and delivery commitments;
    - This Agreement shall remain in force for a period of [1/2/3] years from the effective date, unless terminated earlier in accordance with this Agreement.
    - Either Party may terminate the Agreement with 30 days' written notice, excluding cases of material breach.`,
    forceMajeure: "Neither Party shall be held liable for failure to perform obligations due to causes beyond their reasonable control, including natural disasters, strikes, labor unrest, war and economic factors.",
    disputeResolution: "Any disputes arising under or in connection with this Agreement shall first be resolved through mutual consultation. If unresolved after 30 days, the matter shall be referred to mediation or arbitration in accordance with the laws of South Africa.",
    governingLaw: "The Agreement shall be governed by and construed in accordance with the laws of the Republic of South Africa.",
    miscellaneous: `- This Agreement represents the entire understanding between the Parties.
    - No amendment shall be made in writing signed by both Parties.
    - Schedules A and B are integral parts of this Agreement.`,
    end: `IN WITNESS WHEREOF, the Parties hereto have executed this Offtake Partnership Agreement on the date first above written.`
  });
  const handleContentChange = (section, value) => {
    setSectionContent(prev => ({
      ...prev,
      [section]: value
    }));
  };
  const dropdownItems = {
      FACILITATOR: [
          "**Input Supply (VIS)**",
          "Seeds, fertilizers, pesticides, machinery Financial services (credit, insurance) Extension services and training.", 
          "",
          "**Production (VPR)**",
          "Farming activities (planting, irrigating, tending crops/livestock) Harvesting",
          "",
          "**Post-Harvest Handling (VPH)**",
          " Cleaning, sorting, grading Primary storage Packaging", 
          "",
          "**Processing (VPR)**",
          "Milling, drying, canning, juicing, meat processing Adding preservatives, branding, or recipes", 
          "",
          "**Distribution and Marketing (VDM)**",
          "Transportation Wholesaling Retailing Market access platforms",
          "",
          "**Consumption (VCO)**",
          "Households Restaurants Institutions (schools, hospitals)",
          "",
          "**Support Services (VSS) (Cross-cutting)**",
          "(Cross-cutting) Research and development Infrastructure (roads, electricity, water) ICT and digital tools Policy and regulatory frameworks",
      ],
      PURPOSE: [
          "Funding", 
          "Training", 
          "Resourcing", 
          "Market", 
          "Internship", 
          "Research", 
          "Innovation", 
          "M&E", 
          "Assessment", 
          "Evaluations", 
          "Impact", 
          "EIA", 
          "Development", 
          "Regulation"
      ]
  };
  
  const [dropdownSelections, setDropdownSelections] = useState({
      user_type: dropdownItems.FACILITATOR[0],
      user_purpose: dropdownItems.PURPOSE[0],
  });

  const handleDropdownChange = (type, value) => {
      const keyMap = {
          FACILITATOR: "user_type",
          PURPOSE: "user_purpose",
      };
      if (type === "FACILITATOR") {
          setDropdownSelections(prev => ({
              ...prev,
              user_type: value
          }));
          console.log("User type selected:", value);
      }

      const mappedKey = keyMap[type];
      setDropdownSelections((prev) => ({
          ...prev,
          [mappedKey]: value,
      }));

      console.log({
          user_type: type === "FACILITATOR" ? value : dropdownSelections.user_type,
          user_purpose: type === "PURPOSE" ? value : dropdownSelections.user_purpose,
      });
  };

  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false, onClick = null) => {
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
    
    return (
      <div 
        className="flex items-center cursor-pointer"
        onClick={onClick}
      >
        <div className={`${bgColorClasses[bgColor]} text-white text-[8px] md:text-[16px] px-2 md:px-4 ${
            isLarge ? "py-[3px] md:py-[14px]" : "py-[3px] md:py-[14px]"
        } rounded-l-md font-bold w-[50px] md:w-[250px] whitespace-nowrap flex items-center h-full`}>
            {text}
        </div>
        
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-2 justify-center md:w-[57px] md:h-[52px] rounded-r-md`}>
            <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[20px] h-[6px] md:h-[40px] md:w-[55px] object-contain"
            />
        </div>
        
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px] h-[14px] rounded-r-md`}>
            <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[6px] object-contain"
            />
        </div>
      </div>
    );
  };
  return (
      <div className='bg-white'>
          <div className='px-4 md:px-24'>
              <div className='pt-2 md:pt-8'>
                  <div className='flex justify-between'>
                      <h1 className='text-[12px] md:text-[36px] font-bold text-[#152C24]'>MARKET</h1>

                      <div className="w-auto">
                          <Dropdown1
                              label="LANGUAGE"
                              items={language.FACILITATOR}
                              type="FACILITATOR"
                              isLanguageDropdown={false}
                              onChange={handleDropdownChange}
                          />
                      </div>
                      <div>
                      <h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2">
        {activeTab === "individual" 
          ? "FARMER REGISTRATION ID" 
          : "ORGANIZATION - SIGN UP"}
      </h1>
<div className="flex w-fit">
          <button
           
              className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
              <input className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>

              
          </button>
          <div
              className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
           >
              <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-2 h-[10px] md:w-6 md:h-[24px]"
              />
          </div>
      </div>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Insert ID Number
      </p>

</div>
                  </div>
              </div>
              
              <div className="flex justify-between mt-2 md:mt-6 max-w-3xl mx-auto px-1">
                  <span
                      className="text-[12px] md:text-[36px] font-bold cursor-pointer"
                      onClick={() => setActiveTab("individual")}
                  >
                      Individual
                  </span>
                  <span
                      className="text-[12px] md:text-[36px] font-bold cursor-pointer"
                      onClick={() => setActiveTab("organization")}
                  >
                      Organization
                  </span>
              </div>

              <div className="flex w-full mx-auto rounded-[10px] overflow-hidden h-[9px] mt-2">
                  <button
                      onClick={() => setActiveTab("individual")}
                      className={`w-1/2 transition-all duration-300 ${
                          activeTab === "individual" ? "bg-[#152C24]" : "bg-[#D9D9D9]"
                      }`}
                  ></button>
                  <button
                      onClick={() => setActiveTab("organization")}
                      className={`w-1/2 transition-all duration-300 ${
                          activeTab === "organization" ? "bg-[#152C24]" : "bg-[#D9D9D9]"
                      }`}
                  ></button>
              </div>
              
              <div className="mt-2 md:mt-6"> 
                  <div className="flex items-center gap-2">
                      <div className="w-auto">
                          <Dropdown
                              label="LANGUAGE"
                              items={language1.FACILITATOR}
                              type="FACILITATOR"
                              isLanguageDropdown={false}
                              onChange={handleDropdownChange}
                              activeTab={activeTab}  // Add this line
                          />
                      </div>
                      <div>
<h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2 ">USER NUMBER</h1>
<div className="flex w-fit">
          <button
           
              className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
              <input className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>

              
          </button>
          <div
              className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
           >
              <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-2 h-[10px] md:w-6 md:h-[24px]"
              />
          </div>
      </div>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Insert ID Number
      </p>

</div>
<div>
<h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2 ">--</h1>
<div className="flex w-fit">
          <button
           
              className={`xl:w-[280px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
              <input className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white" placeholder="--"/>

              
          </button>
          <div
              className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
           >
              <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-2 h-[10px] md:w-6 md:h-[24px]"
              />
          </div>
      </div>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
    --
      </p>

</div>
<div>
<h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2 ">--</h1>
<div className="flex w-fit">
          <button
           
              className={`xl:w-[280px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
              <input className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white" placeholder="--"/>

              
          </button>
          <div
              className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
           >
              <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-2 h-[10px] md:w-6 md:h-[24px]"
              />
          </div>
      </div>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
    --
      </p>

</div>
</div>
</div>
           <div className="text-[12px] md:text-[36px] font-normal space-y-4 md:mt-8 mt-4 md:space-y-10 leading-snug">
          <h1 className="font-bold text-[#979797]">Farmer | <span className='text-black'>Contract Farming</span></h1>
          <h2 className="font-bold">OFFTAKE PARTNERSHIP AGREEMENT</h2>

          <p>
            This Offtake Partnership Agreement ("Agreement") is made and entered into on this{" "}
            <span className="font-bold">___</span> day of <span className="font-bold">__________</span>, 20
            <span className="font-bold">___</span>, by and between:
          </p>

          <p>
            <span className="font-bold">[Aggregator Company Name]</span>, a company incorporated under the laws of
            South Africa, with its principal place of business at [Insert Address] (hereinafter referred to as the
            "Aggregator"),
          </p>

          <p>
            - And -
            <br />
            A collective of participating farmers in South Africa, represented by{" "}
            <span className="font-bold">[Insert Farmers' Representative Name or Entity]</span>, with principal location
            at [Insert Address] (hereinafter referred to as the "Farmers"),
            <br />
            Each a "Party" and collectively referred to as the "Parties."
          </p>

          {/* Editable Sections */}
          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              1. Purpose
        
              <div>
              {activeTab === "individual" 
          ? "" 
          : 
          <EditButton section="purpose" />}
              </div>
            </h3>
            {editableSections.purpose ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.purpose}
                onChange={(e) => handleContentChange('purpose', e.target.value)}
                rows={4}
              />
            ) : (
              <p>{sectionContent.purpose}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              2. Scope of Partnership
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="scope" />}
            </h3>
            {editableSections.scope ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.scope}
                onChange={(e) => handleContentChange('scope', e.target.value)}
                rows={6}
              />
            ) : (
              <p className="whitespace-pre-line">{sectionContent.scope}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between  items-center">
              3. Purchase Commitments
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="purchase" />}
            </h3>
            {editableSections.purchase ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.purchase}
                onChange={(e) => handleContentChange('purchase', e.target.value)}
                rows={6}
              />
            ) : (
              <p className="whitespace-pre-line">{sectionContent.purchase}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">

              4. Obligations of the Farmers
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="obligationsFarmers" />}
            </h3>
            {editableSections.obligationsFarmers ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.obligationsFarmers}
                onChange={(e) => handleContentChange('obligationsFarmers', e.target.value)}
                rows={4}
              />
            ) : (
              <ul className="list-disc ml-4 md:ml-10 whitespace-pre-line">
                {sectionContent.obligationsFarmers.split(';').map((item, index) => (
                  item.trim() && <li key={index}>{item.replace('-', '').trim()}</li>
                ))}
              </ul>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex  justify-between items-center">
              5. Obligations of the Aggregator
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="obligationsAggregator" />}
            </h3>
            {editableSections.obligationsAggregator ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.obligationsAggregator}
                onChange={(e) => handleContentChange('obligationsAggregator', e.target.value)}
                rows={8}
              />
            ) : (
              <ul className="list-disc ml-4 md:ml-10 whitespace-pre-line">
                {sectionContent.obligationsAggregator.split(';').map((item, index) => (
                  item.trim() && <li key={index}>{item.replace('-', '').trim()}</li>
                ))}
              </ul>
            )}
          </div>

          {/* Continue with the remaining sections in the same pattern */}
          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              6. Force Majeure
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="forceMajeure" />}
            </h3>
            {editableSections.forceMajeure ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.forceMajeure}
                onChange={(e) => handleContentChange('forceMajeure', e.target.value)}
                rows={4}
              />
            ) : (
              <p>{sectionContent.forceMajeure}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              7. Dispute Resolution
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="disputeResolution" />
              }
            </h3>

            {editableSections.disputeResolution ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.disputeResolution}
                onChange={(e) => handleContentChange('disputeResolution', e.target.value)}
                rows={4}
              />
            ) : (
              <p>{sectionContent.disputeResolution}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              8. Governing Law
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="governingLaw" />
              }
            </h3>
            {editableSections.governingLaw ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.governingLaw}
                onChange={(e) => handleContentChange('governingLaw', e.target.value)}
                rows={4}
              />
            ) : (
              <p>{sectionContent.governingLaw}</p>
            )}
          </div>

          <div className="relative">
            <h3 className="font-bold flex justify-between items-center">
              9. Miscellaneous
              {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="miscellaneous" />
              }
            </h3>
            {editableSections.miscellaneous ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.miscellaneous}
                onChange={(e) => handleContentChange('miscellaneous', e.target.value)}
                rows={6}
              />
            ) : (
              <ul className="list-disc ml-4 md:ml-10 whitespace-pre-line">
                {sectionContent.miscellaneous.split(';').map((item, index) => (
                  item.trim() && <li key={index}>{item.replace('-', '').trim()}</li>
                ))}
              </ul>
            )}
          </div>

    <div className="relative">
    <p className='flex  '>
    {editableSections.end ? (
              <textarea
                className="w-full p-2 border rounded text-[12px] md:text-[24px]"
                value={sectionContent.end}
                onChange={(e) => handleContentChange('end', e.target.value)}
                rows={6}
              />
            ) : (
              <ul className="">
                {sectionContent.end.split(';').map((item, index) => (
                  item.trim() && <li key={index}>{item.replace('-', '').trim()}</li>
                ))}
              </ul>
            )}
            <p className='font-bold'>
            {activeTab === "individual" 
          ? "" 
          : 
              <EditButton section="end" />
              }
            </p>
          </p>
      
        </div>
              
              <div className='md:mt-8 mt-4'>
                  <Dropdown2  
                      label="LANGUAGE"
                      items={language2.FACILITATOR}
                      type="FACILITATOR"
                      isLanguageDropdown={false}
                      onChange={handleDropdownChange}
                  /> 
              </div>
              
              <div>
              <div className="grid grid-cols-4 gap-1 md:gap-16 mb-3 md:mb-6">
  {images.slice(0, 2).map((img, index) => (
    <div key={index} className="flex flex-col mt-1 md:mt-6">
      <p className="text-[8px] md:text-[24px] font-bold mb-1 md:mb-1 text-left md:w-[260px] leading-tight">
      {boxPlaceholders[index]}
      </p>
      <div className="relative bg-[#D9D9D9] rounded-[5px] h-[50px] md:h-[350px] w-full overflow-hidden">
        {img ? (
          <>
            <img
              src={img.previewUrl}
              alt="Certificate"
              className="object-cover w-full h-full"
            />
            {activeTab === "organization" && (
              <div className="absolute md:bottom-2 md:right-2 bottom-1 right-1">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746296659/Trash_ya7kiu.png"
                  alt="Trash Icon"
                  className="w-3 md:w-[24px] h-3 md:h-[24px] cursor-pointer"
                  onClick={() => handleDeleteImage(index)}
                />
              </div>
            )}
          </>
        ) : (
          activeTab === "organization" && (
            <label className="absolute top-1 right-1 md:top-2 md:right-2 cursor-pointer">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745668623/Add_square_duotone_gz7vxe.png"
                alt="Add Icon"
                className="w-4 md:w-[40px] h-4 md:h-[40px]"
              />
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => handleImageChange(e, index)}
                className="hidden"
              />
            </label>
          )
        )}
      </div>
    </div>
  ))}
</div>
              </div>
              
              <div className="flex justify-end">
                  <SaveButtonWithModal/>
              </div>
              <div className="flex gap-2 md:gap-4 items-center mt-3 md:mt-5">
                  <div
                      className="w-6 h-[20px] md:w-16 md:h-[63px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                      onClick={() => {
                          setAgreed((prev) => !prev);
                          setShowAgreementError(false);
                      }}
                      tabIndex={0}
                      aria-pressed={agreed}
                      aria-label="Confirm terms and conditions">
                      {agreed ? (
                          <svg
                              width="54"
                              height="54"
                              viewBox="0 0 54 54"
                              fill="none"
                              className="w-[20px] h-[20px] md:w-[54px] md:h-[54px] transition-all duration-150"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="27" cy="27" r="27" fill="#152C24"/>
                              <path
                                  d="M39 21L24.75 35L15 25.4545"
                                  stroke="white"
                                  strokeWidth="4"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                              />
                          </svg>
                      ) : (
                          <svg
                              width="54"
                              height="54"
                              viewBox="0 0 54 54"
                              fill="none"
                              className="w-[20px] h-[20px] md:w-[54px] md:h-[54px] transition-all duration-150"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="27" cy="27" r="27" fill="#222"/>
                              <path
                                  d="M39 21L24.75 35L15 25.4545"
                                  stroke="white"
                                  strokeWidth="4"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                              />
                          </svg>
                      )}
                  </div>
                  <p className="text-[8px] md:text-[20px]">
                      By ticking I confirm that I agree with the{" "}
                      <a className="underline hover:text-[#152C24]" href="/TermsAndCondition">
                          Terms and conditions
                      </a>
                      ,<a href="/DataPolicy" className="underline hover:text-[#152C24]">Data </a>and{" "}
                      <a className="underline hover:text-[#152C24]" href="/PrivacyPolicy">
                          Privacy policy
                      </a>.
                      <p className={`text-[8px] md:text-[14px] ${
                          agreed ? "text-white hidden" : "text-red-600 cursor-not-allowed"
                      }`}>
                          Please agree to the terms and conditions before proceeding.
                      </p>
                  </p>
              </div>
              
              <button
        className={`w-full flex justify-center md:text-[28px] text-[8px] mt-1 font-bold items-center md:mt-14 border-b-[3px] md:py-1 py-1 text-center md:h-[74px] h-[20px] ${
agreed && !loading
? "bg-[#152C24] text-white border-[#FDBD26]"
: "bg-gray-400 text-gray-200 border-gray-300 cursor-not-allowed"
}`}
              >
                  {loading ? "Processing..." : "Register"}
              </button>
              
       
              <div className='flex justify-end items-center gap-2 md:gap-10 mt-2 md:mt-4'>
  {activeTab === "individual" && ( // Keep contact admin only in individual tab
    <div>
      <button className="flex items-center justify-between w-[60px] md:w-[300px] h-[20px] md:h-[46px] bg-[#2E453D] text-white text-[8px] md:text-[14px] font-bold rounded-[5px] px-1 md:px-4">
        <span>CONTACT ADMIN</span>
        <img 
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747168118/User_cicrle_duotone_kaenga.png" 
          alt="Edit Icon" 
          className="w-[6px] h-[6px] md:w-[35px] md:h-[38px]" 
        />
      </button>
      <p className="text-[8px] md:text-[14px] mt-1 font-normal md:px-1">
        For official use only
      </p>
    </div>
  )}
  <div>
  {renderButtonWithIcon(
    activeTab === "individual" ? "DOWNLOAD REPORTS" : "VIEW CONTRACTS", 
    "#152C24", 
    "#FDBB26", 
    true
  )}
  <p 
    className="text-[8px] md:text-[14px] font-normal mt-1 cursor-pointer"
    onClick={() => {
      if (activeTab === "organization") {
        navigate("/Contract");
      }
    }}
  >
    {activeTab === "individual" ? "Click to download reports" : "View existing contracts"}
  </p>
</div>
</div>
          </div>
          </div>
          </div>

  );
};

export default Market;